<template>
  <div class="page-print" v-if="!loading">
      <div class="print">
        <div v-for="(select, index) in print_order" :key="index">
          <div class="parent-print">
            <div class="header-print">
              <div class="right-header flex items-center">
                <h3 >الفرع المسئول: {{ select.responsible_branch }} </h3>
              </div>
              <div class="center-header">
                <img class="barcode" :src="select.bar_code"  alt="Barcode"/>
                <span>{{ select.code }}</span>
                <h1 class="code">كود الطلب : {{ select.code }}</h1>
              </div>
              <div class="left-header">
                <div class="logo">
                  <img :src="image" alt="Logo" />
                </div>
              </div>
            </div>
            <div class="footer-print">
              <table>
                <thead>
                  <tr>
                    <th>المرسل : {{ select.main_client }}</th>
                    <th>المستلم : {{ select.receiver }}</th>
                    <th>المتجر الفرعي : {{ select.second_client }}</th>
                    <th>القيمة : {{ select.amount_to_be_collected }}</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="information">
              <div class="right-information">
                <p>العنوان : {{ select.address }}</p>
                <p>مسار المدينة : {{ select.government_path }}</p>
                <p>مسار المنطقة : {{ select.area_path }}</p>
                <p>محتوي الطلب : {{ select.order_summary }}</p>
              </div>
              <div class="left-information">
                <p>المدينة : {{ select.government }}</p>
                <p> المنطقة : {{ select.area }}</p>
                <p>{{  select.can_open===0?'ممنوع  فتح الشحنة':'يمكن فتح الشحنة' }}</p>
                <p v-if="select.is_fragile == 1">{{  $t("securePackagingShipment")}}</p>
              </div>
              <div class="left-information">
                <p>التليفون : {{ select.phone1 }}</p>
                <p>رقم المرسل : {{ select.responsible_mobile }}</p>
                <p>{{  select.is_measurable===0?'ممنوع  قياس الشحنة ':'يمكن قياس الشحنة' }}</p>
                <p>ملاحظات : {{ select.notes }}</p>
              </div>
            </div>
            <section class="mb-5"
            v-if="select.order_products.length > 0"
            >
            <div class="content">
              <h2 class="text-center font-bold mb-5">المنتجات</h2>
              <div class="flex items-center justify-around mb-2"
              v-for="(product, index) in select.order_products" :key="index"
              >
              <p class="font-bold text-black">
                <span class="font-bold text-black">اسم المنتج :</span>
                {{ product.client_product.name }}</p>
              <p class="font-bold text-black">
                <span class="font-bold text-black">كود ال sku  للمنتج :</span>
                {{ product.client_product.sku }}</p>
                <p class="font-bold text-black"><span class="font-bold text-black">الكمية :</span> {{ product.quantity }}</p>
              </div>
            </div>
            </section>
          </div>
          <div id="break-page"></div>
        </div>
      </div>
    </div>
  <div v-else class="flex justify-center w-full h-full items-center">
    <SpinnerColor2Vue />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SpinnerColor2Vue from "../components/table-components/SpinnerColor2.vue";

export default {
  data() {
    return {
      selected: "",
      image: process.env.VUE_APP_CONFIGS_MAIN_LOGO,
      loading: false,
    };
  },
  computed: {
    ...mapGetters("dataList", ["detail_of_order", "print_order"]),
  },
  methods: {
    ...mapActions("dataList", ["orderDetails", "printOrder"]),
    printNow() {
      this.loading = false;
      setTimeout(function () {
        window.print();
      }, 500);
    },
  },
  components: { SpinnerColor2Vue },
  async created() {
    this.loading = true;
    if (this.$route.query.selected) {
      this.selected = this.$route.query.selected;
      await this.printOrder(this.selected);
    } else await this.printOrder(this.$route.params.id);
    
    this.printNow();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_variables.scss";
#break-page {
  page-break-after: always;
  page-break-inside: avoid;
}

.parent-print {
  margin: auto;
  border: 1px solid #9f9b9be0;
  padding: 17px 20px;
  border-radius: 4px;
  margin-bottom: 25px;
  margin-top: 10px;
}
.header-print {
  display: flex;
  justify-content: space-between;
}
.right-header h3 {
  font-size: 15px;
  font-weight: bold;
  line-height: 17px;
  margin-bottom: 8px;
  color: #000;
}
.center-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 200px;
}
.left-header {
  text-align: right;
}
.logo {
  width: 72px;
  margin-bottom: 35px;
  padding-top: 11px;
}
.logo svg{
    width: 100%;
    height: auto; /* or a specific height, if desired */
}
.code {
  color: #000;
  font-weight: bold;
  font-size: 15px;
  line-height: 24px;
  text-decoration: unset;
  text-align: center;
}
.barcode {
  height: 56px;
  width: 120px;
}
.information {
  display: flex;
  justify-content: space-between;
}
.right-information {
  width: 60%;
}
.left-information {
  width: 40%;
}
.right-information p,
.left-information p {
  font-size: 12px;
  line-height: 12px;
  font-weight: bold;
  margin-bottom: 12px;
  color: #000;
  word-break: break-all;
}
.footer-print {
  margin-top: 20px;
  margin-bottom: 17px;
}
.footer-print table {
  width: 100%;
  border-collapse: collapse;
}
.footer-print table thead tr th {
  border: solid 1px #70707061;
  text-align: center;
  padding: 8px;
  color: #212121;
  font-weight: 600;
}
.line {
  border-bottom: 0.03125rem solid #70707061;
  opacity: 50%;
  margin-bottom: 1.3rem;
}
.print {
  background: #fff;
  padding: 12px;
  border: 1px solid #70707061;
  border-radius: 4px;
}
</style>
<style lang="scss">
@media print {
  .vx-navbar-wrapper.nav-menu-wrapper,
  .title-page,
  .the-footer,
  .line {
    display: none !important;
  }
  .navbar-floating .vx-navbar-wrapper {
    display: none !important;
  }
  .main-ticket {
    display: none;
  }
  .print {
    padding: 0px;
    border-radius: none;
    border: none;
  }
}

</style>
